import { createAction, handleActions } from "redux-actions"
import { apiGet, apiPost } from "../utils/apiConnector"
import {
  storeListApi,
  storageSearchApi,
  storageAllFilterApi,
} from "../config/apiUrls"

const defaultState = {
  data: [],
  isLoading: false,
}

const test = createAction("TEST")
const setProductsData = createAction("SET_PRODUCTS_DATA")
const setFilters = createAction("SET_FILTERS")
const setLoading = createAction("SET_LOADING")

const reducers = handleActions(
  {
    [test]: (state, { payload }) => ({
      ...state,
      newDate: payload,
    }),
    [setProductsData]: (state, { payload }) => ({
      ...state,
      data: payload,
    }),
    [setLoading]: (state, { payload }) => ({ ...state, isLoading: payload }),
  },
  defaultState,
)

export default reducers

// Thunk
export function getProducts() {
  return (dispatch) => {
    dispatch(setLoading(true))
    apiGet(storeListApi)
      .onOk((res) => {
        dispatch(setProductsData(res.data.response))
        dispatch(setLoading(false))
      })
      .start()
  }
}

export function setCategory(parentId, name) {
  return (dispatch) => {
    apiPost(storageSearchApi, { parentId: parentId, name: name })
      .onOk((res) => {
        dispatch(getProducts())
      })
      .start()
  }
}
